import { useTranslation } from 'react-i18next';

import styles from './PendingInvoiceNotice.module.css';

// PARA-131 (AC-13b, AD-2) — баннер неоплаченного счёта. НАМЕРЕННО обезличен:
// GET /billing/me не отдаёт тариф счёта, а догадка о нём разрушительна —
// POST с чужим тарифом гасит существующий PENDING и выпускает второй счёт
// (create_subscription.py, Р-10 PARA-130). Кнопки оплаты здесь тоже нет:
// оплата завершается штатной кнопкой нужного тарифа в прайсе прямо под ним.
export function PendingInvoiceNotice(): JSX.Element {
  const { t } = useTranslation('billing');

  return (
    <p className={styles.notice} data-testid="pending-invoice-notice">
      {t('pendingInvoice.text')}
    </p>
  );
}
